export default "__VITE_ASSET__CfWKs0rH__"